export type BiomassProjectionScenarioSummaryInput = {
  stage: 'Active' | 'Inactive'
  expectedMortalityRate: number | null
  projectedBiomassKg: number | null
  projectedBiomassCurrentTrendKg: number | null
}

export type BiomassProjectionScenarioSummary = {
  projectedLotsCount: number
  projectedTrendLotsCount: number
  averageExpectedMortalityRate: number | null
  totalProjectedBiomass: number | null
  totalProjectedBiomassCurrentTrend: number | null
}

export const deriveBiomassProjectionScenarioSummary = (
  rows: BiomassProjectionScenarioSummaryInput[]
): BiomassProjectionScenarioSummary => {
  let totalProjectedBiomass = 0
  let totalProjectedBiomassCurrentTrend = 0
  let expectedMortalitySum = 0
  let projectedLotsCount = 0
  let projectedTrendLotsCount = 0

  rows.forEach((row) => {
    if (row.stage !== 'Active') return

    if (row.projectedBiomassKg !== null && row.expectedMortalityRate !== null) {
      totalProjectedBiomass += row.projectedBiomassKg
      expectedMortalitySum += row.expectedMortalityRate
      projectedLotsCount += 1
    }

    if (row.projectedBiomassCurrentTrendKg !== null) {
      totalProjectedBiomassCurrentTrend += row.projectedBiomassCurrentTrendKg
      projectedTrendLotsCount += 1
    }
  })

  return {
    projectedLotsCount,
    projectedTrendLotsCount,
    averageExpectedMortalityRate: projectedLotsCount > 0 ? expectedMortalitySum / projectedLotsCount : null,
    totalProjectedBiomass: projectedLotsCount > 0 ? totalProjectedBiomass : null,
    totalProjectedBiomassCurrentTrend: projectedTrendLotsCount > 0 ? totalProjectedBiomassCurrentTrend : null
  }
}
